// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3K2TB"};